<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="display: flex">
        <v-select :disabled="disabled"
                :items="options.items"
                item-value="value"
                item-text="key"
                :value="value"
                @change="update">
            <template v-slot:item="data">
                <div :class="data.item.class">{{data.item.key}}</div>
            </template>
            <template v-slot:selection="data">
                <div :class="data.item.class">{{data.item.key}}</div>
            </template>
        </v-select>
    </div>
</template>

<script>
    export default {
        name: "DropDown",

        props: {
            value: {
                required: true
            },
            name: {
                type: String,
                required: false
            },
            options: {
                type: Object,
                required: true
            },
            disabled: {
                type: Boolean
            }
        },

        methods: {
            update(value) {
                this.$emit('input', value);
            }
        },

        created() {
            const selected = this.options.items.find(entry => entry.value === this.value);
            if (!selected) {
                this.update("");
            }
        }
    }
</script>

<style scoped>
    .systemDefault {
        color: gray;
        font-size: 0.9rem;
    }
</style>
